module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/phone-model.a50c0613.png";